export default __webpack_public_path__ + "assets/images/active.583a8b.png";